import React, { useContext, useRef, useEffect } from "react"
// import PropTypes from "prop-types"

import Heading from "./Heading"
import Link from "./LinkTM"
import EmailCapture from "./EmailCapture"
import { AppContext } from "./Context"

import styles from "./footer.module.scss"
import headerStyles from "./header.module.scss"
import { graphql, useStaticQuery } from "gatsby"


const Footer = ({ location, setFooterEl }) => {

  const data = useStaticQuery(graphql`
    query FooterQuery {
      contentfulMainFooter(componentName: {eq: "Site Footer"}) {
        linkGroups {
          heading {
            ...HeadingFragment
          }
          links {
            ...LinkFragment
          }
        }
        socialLinkGroup {
          heading {
            ...HeadingFragment
          }
          links {
            ...LinkFragment
          }
        }
        emailCaptureHeading
        emailCaptureSubmitText
        emailCaptureConfirmationText
      }
    }
  `)

  const {
    linkGroups,
    socialLinkGroup,
    emailCaptureHeading,
    emailCaptureSubmitText,
    emailCaptureConfirmationText,
  } = data.contentfulMainFooter

  const appState = useContext(AppContext)

  const footerEl = useRef(null)
  useEffect(() => {
    setFooterEl(footerEl)
  }, [setFooterEl])

  return (
    <footer
      className={`
        ${(location.pathname === "/") ? headerStyles.footerContainer : ""}
        ${styles.container} ${(appState.navOpen) ? styles.navOpen : ""}
      `}
      ref={footerEl}
    >
      {!location.pathname.includes("/cart") &&
        <>
          {linkGroups.map((group, i) => (
            <section
              key={i}
              className={styles.linkGroup}
            >
              {group.heading &&
              <Heading
                tag="h4"
                level="5"
                className={styles.heading}
              >
                {group.heading.heading}
              </Heading>
              }
              <ul className={styles.linkList}>
                {group.links.map((link, j) => (
                  <li
                    key={j}
                    className={styles.linkItem}
                  >
                    <Link
                      url={`${link.url.split("#")[0]}?origin=footer#${link.url.split("#")[1] || ""}`}
                      text={link.text}
                      className={styles.link}
                    />
                  </li>
                ))}
              </ul>
            </section>
          ))}
          <section className={styles.contactGroup}>
            <p className={styles.phone}>
              <a href="tel:8664195500" className={styles.link}>(866) 419-5500</a>
            </p>
            <p className={styles.email}>
              <a href="mailto:atyourservice@tamaramellon.com" className={styles.link}>atyourservice@tamaramellon.com</a>
            </p>
            <div className={styles.emailCapture}>
              {emailCaptureHeading &&
              <Heading
                tag="h4"
                level="4"
                className={styles.heading}
              >
                {emailCaptureHeading}
              </Heading>
              }
              <EmailCapture
                submitText={emailCaptureSubmitText}
                confirmationText={emailCaptureConfirmationText}
                listId="Ni4asD"
                source="Footer"
                formName="Footer"
                offerDiscountCode={false}
                location={location}
              />
            </div>
          </section>
          {socialLinkGroup &&
          <section className={styles.socialGroup}>
            <ul className={styles.linkList}>
              {socialLinkGroup.links.map((link, index) => (
                <li
                  key={index}
                  className={styles.linkItem}
                >
                  <Link
                    url={link.url}
                    text={link.text}
                    image={link.image}
                    className={styles.link}
                  />
                </li>
              ))}
            </ul>
          </section>
          }
        </>
      }
      <section className={styles.legalGroup}>
        <p className={styles.copyright}>
          &copy;2020 Tamara Mellon
        </p>
        <Link
          // url="/pages/privacy-policy"
          url="/pages/privacy-policy?origin=footer"
          text="Privacy Policy"
        />
        <Link
          // url="/pages/terms-conditions"
          url="/pages/terms-conditions?origin=footer"
          text="Terms & Conditions"
        />
      </section>
    </footer>
  )
}

export default Footer
